import { render, staticRenderFns } from "./SubmissionNote.vue?vue&type=template&id=2af7a466"
import script from "./SubmissionNote.vue?vue&type=script&lang=js"
export * from "./SubmissionNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports